import { z } from 'zod';
/**
 * Video style of a property (E540, S540-6, spec 100 section 4.11): how
 * composition v4 draws every animated reel of the property. Stored with the
 * brand settings (module 90) and frozen into each version with the brand
 * tokens, so a render never changes after approval.
 */
export const REEL_CARD_STYLES = ['glass', 'solid', 'outline', 'angular'];
/** Behind headings on photos: a soft shadow or a band in the primary colour. */
export const REEL_TEXT_BACKINGS = ['shadow', 'band'];
export const REEL_HEADING_CASES = ['normal', 'upper'];
/** Entrance timing and camera amplitude. */
export const REEL_PACES = ['calm', 'normal', 'lively'];
/** Background colour of graphic scenes, portraits and the outro. */
export const REEL_SURFACES = ['primary', 'secondary', 'text'];
/** A small light logo on photo and video scenes. */
export const REEL_WATERMARKS = ['none', 'top_left', 'top_right'];
export const DEFAULT_REEL_STYLE = {
    card: 'glass',
    text_backing: 'shadow',
    heading_case: 'normal',
    pace: 'normal',
    surface: 'primary',
    watermark: 'none',
    motif_asset_id: null,
};
/** The stored style; fields added later read with their default. */
export const reelStyleSchema = z.object({
    card: z.enum(REEL_CARD_STYLES).default(DEFAULT_REEL_STYLE.card),
    text_backing: z.enum(REEL_TEXT_BACKINGS).default(DEFAULT_REEL_STYLE.text_backing),
    heading_case: z.enum(REEL_HEADING_CASES).default(DEFAULT_REEL_STYLE.heading_case),
    pace: z.enum(REEL_PACES).default(DEFAULT_REEL_STYLE.pace),
    surface: z.enum(REEL_SURFACES).default(DEFAULT_REEL_STYLE.surface),
    watermark: z.enum(REEL_WATERMARKS).default(DEFAULT_REEL_STYLE.watermark),
    /** A PNG or WebP graphic of the property (like a logo) drawn on graphic scenes and the outro; `null` = none. */
    motif_asset_id: z.string().nullable().default(DEFAULT_REEL_STYLE.motif_asset_id),
});
/** Every enum field of the style with its options, in display order (validation and the settings form). */
export const REEL_STYLE_OPTIONS = {
    card: REEL_CARD_STYLES,
    text_backing: REEL_TEXT_BACKINGS,
    heading_case: REEL_HEADING_CASES,
    pace: REEL_PACES,
    surface: REEL_SURFACES,
    watermark: REEL_WATERMARKS,
};
export const REEL_STYLE_CHOICES = Object.keys(REEL_STYLE_OPTIONS);
/** A stored or snapshotted value as a complete style (unknown or missing parts fall back to the defaults). */
export function readReelStyle(value) {
    const parsed = reelStyleSchema.safeParse(value ?? {});
    return parsed.success ? parsed.data : { ...DEFAULT_REEL_STYLE };
}
//# sourceMappingURL=reel-style.js.map